import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { MessageSquare, FileCheck, Printer, Truck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: MessageSquare,
    title: 'Request a Quote',
    desc: "Tell us what you need and we'll provide a fast estimate.",
    color: 'bg-cyan-100 text-cyan-600',
    borderColor: 'border-cyan-200'
  }, {
    icon: FileCheck,
    title: 'Artwork & Proofing',
    desc: "Upload your files or work with our design team. We'll send a proof.",
    color: 'bg-magenta-100 text-magenta-600',
    borderColor: 'border-magenta-200'
  }, {
    icon: Printer,
    title: 'Print & Produce',
    desc: 'Your order goes into production with quality checks throughout.',
    color: 'bg-yellow-100 text-yellow-600',
    borderColor: 'border-yellow-200'
  }, {
    icon: Truck,
    title: 'Deliver or Install',
    desc: 'Shipped Australia-wide or professionally installed (signage).',
    color: 'bg-blue-100 text-blue-600',
    borderColor: 'border-blue-200'
  }];
  return <Section className="bg-gray-50 border-t border-gray-100 overflow-hidden" data-id="element-287">
      <Container data-id="element-288">
        <div className="text-center mb-16" data-id="element-289">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-290">
            How it works
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-291">
            Our streamlined process ensures you get high-quality results on
            time, every time.
          </p>
        </div>

        <div className="relative" data-id="element-292">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-gradient-to-r from-cyan-200 via-magenta-200 to-yellow-200 -z-10 rounded-full" data-id="element-293"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4 lg:gap-8" data-id="element-294">
            {steps.map((step, index) => <div key={step.title} className="flex flex-col items-center text-center group" data-id="element-295">
                <div className="relative mb-6" data-id="element-296">
                  {/* Mascot Illustration Placeholder - using CSS shapes/colors to represent context */}
                  <div className={`w-24 h-24 rounded-full ${step.color} flex items-center justify-center border-4 border-white shadow-lg relative z-10 transform group-hover:scale-110 transition-transform duration-300`} data-id="element-297">
                    <step.icon className="h-10 w-10" data-id="element-298" />

                    {/* Small Mascot Image Overlay */}
                    <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Step mascot" className="absolute -bottom-2 -right-2 w-10 h-auto drop-shadow-md" data-id="element-299" />
                  </div>

                  {/* Step Number */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gray-900 text-white text-sm font-bold flex items-center justify-center border-2 border-white shadow-md z-20" data-id="element-300">
                    {index + 1}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors" data-id="element-301">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-302">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </Container>
    </Section>;
}